import {Rule} from 'antd/lib/form';

export const nameRules: Rule[] = [
    {required: true, message: ''},
];
